import * as React from 'react';

// ps styles init
import { PixelStreamingApplicationStyle } from 'metaeditor4-ui';
export const PixelStreamingApplicationStyles = new PixelStreamingApplicationStyle();

// context
import ContextProvider, { useStreamContext } from './context'

// hooks
import useStreamActions from './hooks.stream/useStreamActions'
import useStreamEvents from './hooks.stream/useStreamEvents'
import useEventListener from './hooks.stream/useEventListener'

// snippets
import Player from './snippets/Player'


const Context = {
  stream: useStreamContext,
}

const Hooks = {
  actions: useStreamActions,
  events: useStreamEvents,
  listener: useEventListener,
}

export {
  ContextProvider as MetaProvider,
  Player as MetaPlayer,
  Context,
  Hooks,
}

// types
import type { PlayerConfigProps } from './context/useStreamContext/types'

export type {
  PlayerConfigProps
}